import React, {useState, useContext, useRef} from 'react'
import { format } from "date-fns";
import {useDispatch, useSelector} from "react-redux";

import GLOBAL from "../../global";
import CONSTANT from "../../constants/Constant";
import ConfirmationDialog from "../shared/Popups/ConfirmationDialog";
import Info from "../../assets/img/utils/info.svg";
import AlertModal from "../shared/AlertModal";
import AppContext from "../../contexts/AppContext";
import Assessment from "../../models/Assessment";
import {toast} from "react-toastify";
import { useHistory } from "react-router-dom";
import routes from "../../constants/Routes";
import {saveIntake} from "../shared/intake-form/intake-form-service";
import useIntakeFrom from "../shared/intake-form/useIntakeFrom";
import useHandleExpiredAndUpcomingMeetingPopupMsg from "../../hooks/useHandleExpiredAndUpcomingMeetingPopupMsg";
import {convertBodyRegionStrIntoBodyRegionListArrayOfNumber} from "../../utils/Utils";
import useChatbot from "../shared/chatbotNew/hooks/useChatbot";
import { useTenantFeatures } from "../../features/tenantFeatures/useTenantFeature";
import "../../assets/sass/components/appointment-event-details/AppointmentEventDetails.scss"

const AppointmentEventDetails = ({ appointmentDetails, close }) => {
    const dispatch = useDispatch();
    let history = useHistory();
    const { setTelemedicineProperties, resetTelemedicineKeys } = useContext(AppContext);
    const { handleOpenIntakeForm, handleCloseIntakeForm, handleSetJoiningTelemedicine } = useIntakeFrom();
    const { getAssessmentAvailabilityStatus, handleOpenUpcomingOrExpiredPopupMessage } = useHandleExpiredAndUpcomingMeetingPopupMsg();
    const { startChatBot } = useChatbot();
    const { isIntakeTelemedicineFormEnable } = useTenantFeatures();

    const intakeFormState = useSelector(state => state.intakeForm);

    const joinNowBtnConfig = intakeFormState?.joinNowBtnConfig || {};
    const joiningTelemedicine = joinNowBtnConfig.joiningTelemedicine || false;

    const patientId = GLOBAL?.USER_INFO?.ContactId || '';
    const [selectedTelemedicineInvObj, setSelectedTelemedicineInvObj] = useState(null);
    const [showDetailInstruction, setShowDetailInstruction] = useState(false);

    const telemedicineJoinNowTextRef = useRef("");
    const confirmDialogContentRef = useRef({});

    const onClickGoToRoom = (e, inv) => {
        e.preventDefault();
        const redirectType = inv['RedirectTypeText'];
        GLOBAL.URL_PARAMS.IS_INTAKE_SIGNED = inv['IsIntakeSigned'];
        GLOBAL.URL_PARAMS.PATIENT_ID = patientId;
        GLOBAL.URL_PARAMS.REDIRECT_TYPE = 'refer';
        GLOBAL.URL_PARAMS.INVITATION_ID = inv.InvitationId;
        GLOBAL.URL_PARAMS.BODY_REGION_LIST = inv.BodyRegionList;
        GLOBAL.URL_PARAMS.EMAIL_ADDRESS = inv.EmailAddress;
        GLOBAL.URL_PARAMS.REFER_TYPE = redirectType;
        GLOBAL.URL_PARAMS.IS_FOLLOWUP = inv['IsFollowup'];
        GLOBAL.URL_PARAMS.TEST_ID = inv.TestId;

        if(!inv.TestId) {
            startChatBot(
                inv, //invitationData
                patientId,
                inv?.MeetingStart, //meetingStart
                inv?.MeetingEnd //meetingEnd
            )
            // dispatch(setOpenChatBot({
            //     invitationData: inv,
            //     patientId,
            //     meetingStart: inv?.MeetingStart,
            //     meetingEnd: inv?.MeetingEnd
            // }));
            return;
        }
        const telemedicineStatus = getAssessmentAvailabilityStatus(inv?.MeetingStart, inv?.MeetingEnd);
        if (telemedicineStatus === CONSTANT.ASSESSMENT_AVAILABILITY.UPCOMING.KEY) {
            telemedicineJoinNowTextRef.current = CONSTANT.ASSESSMENT_AVAILABILITY.UPCOMING.MESSAGE;
        } else if(telemedicineStatus === CONSTANT.ASSESSMENT_AVAILABILITY.EXPIRED.KEY) {
            telemedicineJoinNowTextRef.current = CONSTANT.ASSESSMENT_AVAILABILITY.EXPIRED.MESSAGE;
        } else {
            telemedicineJoinNowTextRef.current = CONSTANT.ASSESSMENT_AVAILABILITY.AVAILABLE.MESSAGES.NO_JOIN_TELEMEDICINE;
        }

        let doesDemoAdlMedCCCompleted =
            (inv?.DemographicsCompleted || false) &&
            (inv?.ADLCompleted || false) &&
            (inv?.MedicalHistoryCompleted || false) &&
            (inv?.ChiefComplaintsCompleted || false);

        if (!doesDemoAdlMedCCCompleted) {
            confirmDialogContentRef.current = {
                headerText: "Attention",
                cancelText: "Update My Background",
                confirmText: telemedicineJoinNowTextRef.current,
                onConfirm: () => {
                    close && close();
                    handleOnClickYesAtConfirmationDialog(inv);
                }, /// Confirm Action =>No, Join Telemedicine
                toggleDialog: () => {
                    close && close();
                    history.push(`${routes.editAssessment}/${inv.TestId}`)
                }, /// Cancel handler =>Update My Background
                onClickHeaderClose: () => setSelectedTelemedicineInvObj(null),
                htmlInnerContent: (
                    <p>Please complete the ADL, MED, and CC fields before joining the telemedicine session.</p>
                ),
                shouldConfirmBtnDisabled: true
            }
        } else {
            confirmDialogContentRef.current = {
                headerText: "Update Your Information?",
                cancelText: "Update My Background",
                confirmText: telemedicineJoinNowTextRef.current,
                onConfirm: () => {
                    close && close();
                    handleOnClickYesAtConfirmationDialog(inv);
                }, /// Confirm Action =>No, Join Telemedicine
                toggleDialog: () => {
                    close && close();
                    history.push(`${routes.editAssessment}/${inv.TestId}`)
                }, /// Cancel handler =>Update My Background
                onClickHeaderClose: () => setSelectedTelemedicineInvObj(null),
                htmlInnerContent: (
                    <p>Would you like to update your background information (Activities of Daily Living, Medical History, Chief Complaints)?
                        <span onClick={() => setShowDetailInstruction(true)} className="edit-assessment-info-container margin-left-1-rem">
                            <img src={Info} alt="Information" className='tele_eye_btn cursor-pointer' />
                        </span>
                    </p>
                ),
                shouldConfirmBtnDisabled: false
            }
        }

        setSelectedTelemedicineInvObj(inv);
    }

    const handleOnClickYesAtConfirmationDialog = (inv) => {
        let assessmentAvailabilityStatus = getAssessmentAvailabilityStatus(inv?.MeetingStart, inv?.MeetingEnd);
        if(assessmentAvailabilityStatus === CONSTANT.ASSESSMENT_AVAILABILITY.UPCOMING.KEY || assessmentAvailabilityStatus === CONSTANT.ASSESSMENT_AVAILABILITY.EXPIRED.KEY) {
            handleOpenUpcomingOrExpiredPopupMessage(assessmentAvailabilityStatus, null, onClose);
        } else {
            onClickJoinTelemedicine(inv);
        }
    }

    const onClickJoinTelemedicine = (inv) => {
        let isIntakeSigned = (GLOBAL.USER_INFO && GLOBAL.USER_INFO['IsIntakeSigned']) || '';
        if (!isIntakeSigned && isIntakeTelemedicineFormEnable) {
            setSelectedTelemedicineInvObj(null);
            handleOpenIntakeForm({
                bodyRegionList: inv?.BodyRegionList || [],
                invitationTypeName: inv?.RedirectTypeText || '',
                showSubmitBtn: true,
                onClickSubmitIntakeForm: onClickSubmitIntakeForm,
                isFromCalendar: true,
            })
        } else {
            openTelemedicineModal();
        }
    }

    const openTelemedicineModal = () => {
        handleSetJoiningTelemedicine(true);
        const { InvitationId, BodyRegion } = appointmentDetails?.data;
        setTelemedicineProperties(InvitationId, convertBodyRegionStrIntoBodyRegionListArrayOfNumber(BodyRegion), onLoadTelemedicineModal, onClose);
    }

    const onClickSubmitIntakeForm = async (values) => {
        handleSetJoiningTelemedicine(true);
        GLOBAL.ASSESSMENT = new Assessment({ TestId: appointmentDetails.data?.TestId });
        const response = await saveIntake(values);
        const { data, success, error } = response;
        if(!success) {
            toast.error(error || 'Failed to save intake form');
            onClose();
            return;
        }
        openTelemedicineModal();
    }

    const onLoadTelemedicineModal = () => {
        handleSetJoiningTelemedicine(false);
        setSelectedTelemedicineInvObj(null);
    }

    const onClose = () => {
        GLOBAL.ASSESSMENT = null;
        handleCloseIntakeForm();
        resetTelemedicineKeys();
        close && close();
    }

    return (
        <>
            <div className="text-center">
                <div className="aed-details margin-bottom-1-rem">
                    <div className="aed-row">
                        <span className="aed-label">Meeting Title</span>
                        <span className="aed-colon">:</span>
                        <span className="aed-value">{appointmentDetails.meetingTitle}</span>
                    </div>

                    <div className="aed-row">
                        <span className="aed-label">Provider Name</span>
                        <span className="aed-colon">:</span>
                        <span className="aed-value">{appointmentDetails.providerName}</span>
                    </div>

                    <div className="aed-row">
                        <span className="aed-label">Provider Email</span>
                        <span className="aed-colon">:</span>
                        <span className="aed-value">{appointmentDetails.providerEmail}</span>
                    </div>

                    <div className="aed-row">
                        <span className="aed-label">Meeting Date</span>
                        <span className="aed-colon">:</span>
                        <span className="aed-value">
      {format(new Date(appointmentDetails.meetingDate), CONSTANT.DATE_FORMAT.MMM_DD_YYYY)}
    </span>
                    </div>

                    <div className="aed-row">
                        <span className="aed-label">Start Time</span>
                        <span className="aed-colon">:</span>
                        <span className="aed-value">
      {format(new Date(appointmentDetails.startTime), CONSTANT.DATE_FORMAT.HH_MM_P_A)}
    </span>
                    </div>

                    <div className="aed-row">
                        <span className="aed-label">End Time</span>
                        <span className="aed-colon">:</span>
                        <span className="aed-value">
      {format(new Date(appointmentDetails.endTime), CONSTANT.DATE_FORMAT.HH_MM_P_A)}
    </span>
                    </div>
                </div>

                <a rel="noopener noreferrer"
                   href={"!#"}
                   onClick={(e) => onClickGoToRoom(e, appointmentDetails.data)}
                   target="_blank"
                   className="btn btn-success margin-1-rem">
                    <i className="padding-right-0-5-rem fa fa-handshake"/>
                    Meet now
                </a>
                <a className="btn btn-danger margin-1-rem" onClick={close}>
                    <i className="padding-right-0-5-rem fa fa-times"/>
                    Close
                </a>
            </div>

            {/*<ConfirmationDialog*/}
            {/*    headerText={confirmDialogContentRef.current?.headerText || ""}*/}
            {/*    show={selectedTelemedicineInvObj !== null}*/}
            {/*    cancelText={confirmDialogContentRef.current?.cancelText || ""}*/}
            {/*    confirmText={confirmDialogContentRef.current?.confirmText || ""}*/}
            {/*    showLoadingInConform={joiningTelemedicine}*/}
            {/*    onConfirm={confirmDialogContentRef.current?.onConfirm || (() => {})}*/}
            {/*    toggleDialog={confirmDialogContentRef.current?.toggleDialog || (() => {})}*/}
            {/*    onClickHeaderClose={confirmDialogContentRef.current?.onClickHeaderClose || (() => {})}*/}
            {/*    shouldConfirmBtnDisabled={confirmDialogContentRef.current?.shouldConfirmBtnDisabled || false}*/}
            {/*>*/}
            {/*    {confirmDialogContentRef.current?.htmlInnerContent || <></>}*/}
            {/*</ConfirmationDialog>*/}

            <AlertModal
                show={selectedTelemedicineInvObj !== null}
                title={confirmDialogContentRef.current?.headerText || ""}
                type="warning"
                onConfirm={confirmDialogContentRef.current?.onConfirm || (() => {})}
                onCancel={confirmDialogContentRef.current?.toggleDialog || (() => {})}
                onClose={confirmDialogContentRef.current?.onClickHeaderClose || (() => {})}
                confirmBtnText={confirmDialogContentRef.current?.confirmText || ""}
                cancelBtnText={confirmDialogContentRef.current?.cancelText || ""}
                showCancel={true}
                showLoadingInConform={false}
                closeOnClickOutside={false}
                showCloseButton={true}
            >
                {confirmDialogContentRef.current?.htmlInnerContent || <></>}
            </AlertModal>


            <AlertModal
                confirmBtnCssClass="btn btn-sm btn-success"
                showConfirm= {true}
                showCancel={false}
                show={showDetailInstruction}
                title=""
                type="info"
                onConfirm={() => setShowDetailInstruction(false)}
                confirmBtnText="Ok"
                closeOnClickOutside={false}>
                <div className='tele_sweetalert_message'>
                    If there have been any notable changes to your weight, daily activities, or your acute or chronic chief complaints,
                    please update these entries by clicking “Update My Background”
                </div>
            </AlertModal>
        </>
    )
}

export default AppointmentEventDetails;
